import {appLink, ISearchResultUniversalParams} from "@rw/cars_routes";
import {omit} from "lodash";

import {appendQueryString, IQueryParams} from "../../../app/utils/append_query_string";
import {OfferType, UOfferTypes} from "../../utils/constants_offer";
import {getMakeSlug} from "../../utils/get_make_slug";
import {toMakePathSlug} from "../../utils/make_slug_to_api_type";
import {buildOfferListPathParams} from "./parse_offer_list_path";
import {validateOfferListTagWithParams} from "./tag_utils";
import {UrlTagSlug} from "./tags";

export enum LocationTypes {
    CITY = "Miasto",
    TOWN = "Miejscowość",
    DISTRICT = "Dzielnica",
    ESTATE = "Osiedle",
    COUNTY = "Powiat",
    VOIVODESHIP = "Województwo"
}

interface IData extends ISearchResultUniversalParams, IQueryParams {
    offerType: UOfferTypes | OfferType;
    tag?: UrlTagSlug;
    /** Logical model filter — placed in path when make is set (not in query). */
    model?: string;
}

/**
 * Returns valid offer list url, appends non-seo-friendly params.
 * When `model` is set with a make, it becomes a path segment after make
 * (disambiguated from voivodeship via parseOfferListPath on read).
 */
export const getOfferListUrl = (params: IData, locationType?: LocationTypes) => {
    const typeSlug = params.type
        ? getMakeSlug(String(params.type)) || toMakePathSlug(String(params.type)) || params.type
        : undefined;
    const validatedParams = validateOfferListTagWithParams({...params, type: typeSlug}, locationType) as IData;
    const {offerType, tag, type, location, subLocation, model, ...restParams} = validatedParams;

    const pathSlots = buildOfferListPathParams({
        type,
        model: model || undefined,
        location,
        subLocation
    });

    const pathParams = {
        offerType,
        ...pathSlots
    };

    const queryRest = omit(restParams, ["model", "subSubLocation"]);
    const url = tag ? appLink.searchResult.universalTag({tag, ...pathParams}) : appLink.searchResult.universal(pathParams);
    return appendQueryString(url, queryRest || {});
};
